<script>
export default {
  name: "nav",
  data() {
    return {
      permissionList: [],
      sidebar: {
        _name: "CSidebarNav",
        _children: [
          {
            _name: "CSidebarNavItem",
            name: "แบทช์คลังสินค้า",
            to: "/batch",
            icon: "cil-list",
          },
          {
            _name: "CSidebarNavItem",
            name: "Scan Tracking",
            to: "/tracking",
            icon: "cil-list",
          },
          {
            _name: "CSidebarNavItem",
            name: "ดำเนินการขนส่ง",
            to: "/shipping",
            icon: "cil-list",
          },
          {
            _name: "CSidebarNavItem",
            name: "ส่งมอบให้ขนส่งเรียบร้อย",
            to: "/transport",
            icon: "cil-list",
          },
          // {
          //   _name: "CSidebarNavItem",
          //   name: "ออเดอร์",
          //   to: "/order",
          //   icon: "cil-list",
          // },
          {
            _name: "CSidebarNavItem",
            name: "ตั้งค่า",
            to: "/setting",
            icon: "cil-settings",
          },
        ],
      },
    };
  },
  computed: {
    sidebarItems() {
      return [this.sidebar];
    },
  },
  created: async function () {},
  methods: {},
};
</script>
